const _excluded = ["list", "setList", "children", "tag", "style", "className", "clone", "onAdd", "onChange", "onChoose", "onClone", "onEnd", "onFilter", "onRemove", "onSort", "onStart", "onUnchoose", "onUpdate", "onMove", "onSpill", "onSelect", "onDeselect"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var $8zHUo$sortablejs = require("sortablejs");
var $8zHUo$classnames = require("classnames");
var $8zHUo$react = require("react");
var $8zHUo$tinyinvariant = require("tiny-invariant");
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function (key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }
    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });
  return dest;
}
$parcel$export(module.exports, "Sortable", () => $882b6d93070905b3$re_export$Sortable);
$parcel$export(module.exports, "Direction", () => $882b6d93070905b3$re_export$Direction);
$parcel$export(module.exports, "DOMRect", () => $882b6d93070905b3$re_export$DOMRect);
$parcel$export(module.exports, "GroupOptions", () => $882b6d93070905b3$re_export$GroupOptions);
$parcel$export(module.exports, "MoveEvent", () => $882b6d93070905b3$re_export$MoveEvent);
$parcel$export(module.exports, "Options", () => $882b6d93070905b3$re_export$Options);
$parcel$export(module.exports, "PullResult", () => $882b6d93070905b3$re_export$PullResult);
$parcel$export(module.exports, "PutResult", () => $882b6d93070905b3$re_export$PutResult);
$parcel$export(module.exports, "SortableEvent", () => $882b6d93070905b3$re_export$SortableEvent);
$parcel$export(module.exports, "SortableOptions", () => $882b6d93070905b3$re_export$SortableOptions);
$parcel$export(module.exports, "Utils", () => $882b6d93070905b3$re_export$Utils);
$parcel$export(module.exports, "ReactSortable", () => $7fe8e3ea572bda7a$export$11bbed9ee0012c13);
function $eb03e74f8f7db1f3$export$1d0aa160432dfea5(node) {
  if (node.parentElement !== null) node.parentElement.removeChild(node);
}
function $eb03e74f8f7db1f3$export$6d240faa51aa562f(parent, newChild, index) {
  const refChild = parent.children[index] || null;
  parent.insertBefore(newChild, refChild);
}
function $eb03e74f8f7db1f3$export$d7d742816c28cf91(customs) {
  $eb03e74f8f7db1f3$export$77f49a256021c8de(customs);
  $eb03e74f8f7db1f3$export$a6177d5829f70ebc(customs);
}
function $eb03e74f8f7db1f3$export$77f49a256021c8de(customs) {
  customs.forEach(curr => $eb03e74f8f7db1f3$export$1d0aa160432dfea5(curr.element));
}
function $eb03e74f8f7db1f3$export$a6177d5829f70ebc(customs) {
  customs.forEach(curr => {
    $eb03e74f8f7db1f3$export$6d240faa51aa562f(curr.parentElement, curr.element, curr.oldIndex);
  });
}
function $eb03e74f8f7db1f3$export$4655efe700f887a(evt, list) {
  const mode = $eb03e74f8f7db1f3$export$1fc0f6205829e19c(evt);
  const parentElement = {
    parentElement: evt.from
  };
  let custom = [];
  switch (mode) {
    case "normal":
      /* eslint-disable */const item = {
        element: evt.item,
        newIndex: evt.newIndex,
        oldIndex: evt.oldIndex,
        parentElement: evt.from
      };
      custom = [item];
      break;
    case "swap":
      const drag = _objectSpread({
        element: evt.item,
        oldIndex: evt.oldIndex,
        newIndex: evt.newIndex
      }, parentElement);
      const swap = _objectSpread({
        element: evt.swapItem,
        oldIndex: evt.newIndex,
        newIndex: evt.oldIndex
      }, parentElement);
      custom = [drag, swap];
      break;
    case "multidrag":
      custom = evt.oldIndicies.map((curr, index) => _objectSpread({
        element: curr.multiDragElement,
        oldIndex: curr.index,
        newIndex: evt.newIndicies[index].index
      }, parentElement));
      break;
  }
  /* eslint-enable */
  const customs = $eb03e74f8f7db1f3$export$bc06a3af7dc65f53(custom, list);
  return customs;
}
function $eb03e74f8f7db1f3$export$c25cf8080bd305ec(normalized, list) {
  const a = $eb03e74f8f7db1f3$export$be2da95e6167b0bd(normalized, list);
  const b = $eb03e74f8f7db1f3$export$eca851ee65ae17e4(normalized, a);
  return b;
}
function $eb03e74f8f7db1f3$export$be2da95e6167b0bd(normalized, list) {
  const newList = [...list];
  normalized.concat().reverse().forEach(curr => newList.splice(curr.oldIndex, 1));
  return newList;
}
function $eb03e74f8f7db1f3$export$eca851ee65ae17e4(normalized, list, evt, clone) {
  const newList = [...list];
  normalized.forEach(curr => {
    const newItem = clone && evt && clone(curr.item, evt);
    newList.splice(curr.newIndex, 0, newItem || curr.item);
  });
  return newList;
}
function $eb03e74f8f7db1f3$export$1fc0f6205829e19c(evt) {
  if (evt.oldIndicies && evt.oldIndicies.length > 0) return "multidrag";
  if (evt.swapItem) return "swap";
  return "normal";
}
function $eb03e74f8f7db1f3$export$bc06a3af7dc65f53(inputs, list) {
  const normalized = inputs.map(curr => _objectSpread(_objectSpread({}, curr), {}, {
    item: list[curr.oldIndex]
  })).sort((a, b) => a.oldIndex - b.oldIndex);
  return normalized;
}
function $eb03e74f8f7db1f3$export$7553c81e62e31b7e(props) {
  /* eslint-disable */const
    // react sortable props
    list = props.list,
    setList = props.setList,
    children = props.children,
    tag = props.tag,
    style = props.style,
    className = props.className,
    clone = props.clone,
    // sortable options that have methods we want to overwrite
    onAdd = props.onAdd,
    onChange = props.onChange,
    onChoose = props.onChoose,
    onClone = props.onClone,
    onEnd = props.onEnd,
    onFilter = props.onFilter,
    onRemove = props.onRemove,
    onSort = props.onSort,
    onStart = props.onStart,
    onUnchoose = props.onUnchoose,
    onUpdate = props.onUpdate,
    onMove = props.onMove,
    onSpill = props.onSpill,
    onSelect = props.onSelect,
    onDeselect = props.onDeselect,
    options = _objectWithoutProperties(props, _excluded);
  /* eslint-enable */
  return options;
}

/** Holds a global reference for which react element is being dragged */ // @todo - use context to manage this. How does one use 2 different providers?
const $7fe8e3ea572bda7a$var$store = {
  dragging: null
};
class $7fe8e3ea572bda7a$export$11bbed9ee0012c13 extends (0, $8zHUo$react.Component) {
  constructor(props) {
    super(props);
    // @todo forward ref this component
    this.ref = /*#__PURE__*/(0, $8zHUo$react.createRef)();
    // make all state false because we can't change sortable unless a mouse gesture is made.
    const newList = [...props.list].map(item => Object.assign(item, {
      chosen: false,
      selected: false
    }));
    props.setList(newList, this.sortable, $7fe8e3ea572bda7a$var$store);
    (0, $parcel$interopDefault($8zHUo$tinyinvariant))(
    //@ts-expect-error: Doesn't exist. Will deprecate soon.
    !props.plugins, `
Plugins prop is no longer supported.
Instead, mount it with "Sortable.mount(new MultiDrag())"
Please read the updated README.md at https://github.com/SortableJS/react-sortablejs.
      `);
  }
  componentDidMount() {
    if (this.ref.current === null) return;
    const newOptions = this.makeOptions();
    (0, $parcel$interopDefault($8zHUo$sortablejs)).create(this.ref.current, newOptions);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.disabled !== this.props.disabled && this.sortable) this.sortable.option("disabled", this.props.disabled);
  }
  render() {
    const _this$props = this.props,
      tag = _this$props.tag,
      style = _this$props.style,
      className = _this$props.className,
      id = _this$props.id;
    const classicProps = {
      style: style,
      className: className,
      id: id
    };
    // if no tag, default to a `div` element.
    const newTag = !tag || tag === null ? "div" : tag;
    return /*#__PURE__*/(0, $8zHUo$react.createElement)(newTag, _objectSpread({
      // @todo - find a way (perhaps with the callback) to allow AntD components to work
      ref: this.ref
    }, classicProps), this.getChildren());
  }
  getChildren() {
    const _this$props2 = this.props,
      children = _this$props2.children,
      dataIdAttr = _this$props2.dataIdAttr,
      _this$props2$selected = _this$props2.selectedClass,
      selectedClass = _this$props2$selected === void 0 ? "sortable-selected" : _this$props2$selected,
      _this$props2$chosenCl = _this$props2.chosenClass,
      chosenClass = _this$props2$chosenCl === void 0 ? "sortable-chosen" : _this$props2$chosenCl,
      _this$props2$dragClas = _this$props2.dragClass,
      dragClass = _this$props2$dragClas === void 0 ? "sortable-drag" : _this$props2$dragClas,
      _this$props2$fallback = _this$props2.fallbackClass,
      fallbackClass = _this$props2$fallback === void 0 ? "sortable-falback" : _this$props2$fallback,
      _this$props2$ghostCla = _this$props2.ghostClass,
      ghostClass = _this$props2$ghostCla === void 0 ? "sortable-ghost" : _this$props2$ghostCla,
      _this$props2$swapClas = _this$props2.swapClass,
      swapClass = _this$props2$swapClas === void 0 ? "sortable-swap-highlight" : _this$props2$swapClas,
      _this$props2$filter = _this$props2.filter,
      filter = _this$props2$filter === void 0 ? "sortable-filter" : _this$props2$filter,
      list = _this$props2.list;
    // if no children, don't do anything.
    if (!children || children == null) return null;
    const dataid = dataIdAttr || "data-id";
    /* eslint-disable-next-line */
    return (0, $8zHUo$react.Children).map(children, (child, index) => {
      if (child === undefined) return undefined;
      const item = list[index] || {};
      const prevClassName = child.props.className;
      // @todo - handle the function if avalable. I don't think anyone will be doing this soon.
      const filtered = typeof filter === "string" && {
        [filter.replace(".", "")]: !!item.filtered
      };
      const className = (0, $parcel$interopDefault($8zHUo$classnames))(prevClassName, _objectSpread({
        [selectedClass]: item.selected,
        [chosenClass]: item.chosen
      }, filtered));
      return /*#__PURE__*/(0, $8zHUo$react.cloneElement)(child, {
        [dataid]: child.key,
        className: className
      });
    });
  }
  /** Appends the `sortable` property to this component */
  get sortable() {
    const el = this.ref.current;
    if (el === null) return null;
    const key = Object.keys(el).find(k => k.includes("Sortable"));
    if (!key) return null;
    //@ts-expect-error: fix me.
    return el[key];
  }
  /** Converts all the props from `ReactSortable` into the `options` object that `Sortable.create(el, [options])` can use. */
  makeOptions() {
    const DOMHandlers = ["onAdd", "onChoose", "onDeselect", "onEnd", "onRemove", "onSelect", "onSpill", "onStart", "onUnchoose", "onUpdate"];
    const NonDOMHandlers = ["onChange", "onClone", "onFilter", "onSort"];
    const newOptions = (0, $eb03e74f8f7db1f3$export$7553c81e62e31b7e)(this.props);
    DOMHandlers.forEach(name => newOptions[name] = this.prepareOnHandlerPropAndDOM(name));
    NonDOMHandlers.forEach(name => newOptions[name] = this.prepareOnHandlerProp(name));
    /** onMove has 2 arguments and needs to be handled seperately. */
    const onMove1 = (evt, originalEvt) => {
      const onMove = this.props.onMove;
      const defaultValue = evt.willInsertAfter || -1;
      if (!onMove) return defaultValue;
      const result = onMove(evt, originalEvt, this.sortable, $7fe8e3ea572bda7a$var$store);
      if (typeof result === "undefined") return false;
      return result;
    };
    return _objectSpread(_objectSpread({}, newOptions), {}, {
      onMove: onMove1
    });
  }
  /** Prepares a method that will be used in the sortable options to call an `on[Handler]` prop & an `on[Handler]` ReactSortable method.  */
  prepareOnHandlerPropAndDOM(evtName) {
    return evt => {
      // call the component prop
      this.callOnHandlerProp(evt, evtName);
      // calls state change
      //@ts-expect-error: until @types multidrag item is in
      this[evtName](evt);
    };
  }
  /** Prepares a method that will be used in the sortable options to call an `on[Handler]` prop */
  prepareOnHandlerProp(evtName) {
    return evt => {
      // call the component prop
      this.callOnHandlerProp(evt, evtName);
    };
  }
  /** Calls the `props.on[Handler]` function */
  callOnHandlerProp(evt, evtName) {
    const propEvent = this.props[evtName];
    if (propEvent) propEvent(evt, this.sortable, $7fe8e3ea572bda7a$var$store);
  }
  // SORTABLE DOM HANDLING
  onAdd(evt) {
    const _this$props3 = this.props,
      list = _this$props3.list,
      setList = _this$props3.setList,
      clone = _this$props3.clone;
    /* eslint-disable-next-line */
    const otherList = [...$7fe8e3ea572bda7a$var$store.dragging.props.list];
    const customs = (0, $eb03e74f8f7db1f3$export$4655efe700f887a)(evt, otherList);
    (0, $eb03e74f8f7db1f3$export$77f49a256021c8de)(customs);
    const newList = (0, $eb03e74f8f7db1f3$export$eca851ee65ae17e4)(customs, list, evt, clone).map(item => Object.assign(item, {
      selected: false
    }));
    setList(newList, this.sortable, $7fe8e3ea572bda7a$var$store);
  }
  onRemove(evt) {
    const _this$props4 = this.props,
      list = _this$props4.list,
      setList = _this$props4.setList;
    const mode = (0, $eb03e74f8f7db1f3$export$1fc0f6205829e19c)(evt);
    const customs = (0, $eb03e74f8f7db1f3$export$4655efe700f887a)(evt, list);
    (0, $eb03e74f8f7db1f3$export$a6177d5829f70ebc)(customs);
    let newList = [...list];
    // remove state if not in clone mode. otherwise, keep.
    if (evt.pullMode !== "clone") newList = (0, $eb03e74f8f7db1f3$export$be2da95e6167b0bd)(customs, newList);else {
      // switch used to get the clone
      let customClones = customs;
      switch (mode) {
        case "multidrag":
          customClones = customs.map((item, index) => _objectSpread(_objectSpread({}, item), {}, {
            element: evt.clones[index]
          }));
          break;
        case "normal":
          customClones = customs.map(item => _objectSpread(_objectSpread({}, item), {}, {
            element: evt.clone
          }));
          break;
        case "swap":
        default:
          (0, $parcel$interopDefault($8zHUo$tinyinvariant))(true, `mode "${mode}" cannot clone. Please remove "props.clone" from <ReactSortable/> when using the "${mode}" plugin`);
      }
      (0, $eb03e74f8f7db1f3$export$77f49a256021c8de)(customClones);
      // replace selected items with cloned items
      customs.forEach(curr => {
        const index = curr.oldIndex;
        /* eslint-disable-next-line */
        const newItem = this.props.clone(curr.item, evt);
        newList.splice(index, 1, newItem);
      });
    }
    // remove item.selected from list
    newList = newList.map(item => Object.assign(item, {
      selected: false
    }));
    setList(newList, this.sortable, $7fe8e3ea572bda7a$var$store);
  }
  onUpdate(evt) {
    const _this$props5 = this.props,
      list = _this$props5.list,
      setList = _this$props5.setList;
    const customs = (0, $eb03e74f8f7db1f3$export$4655efe700f887a)(evt, list);
    (0, $eb03e74f8f7db1f3$export$77f49a256021c8de)(customs);
    (0, $eb03e74f8f7db1f3$export$a6177d5829f70ebc)(customs);
    const newList = (0, $eb03e74f8f7db1f3$export$c25cf8080bd305ec)(customs, list);
    return setList(newList, this.sortable, $7fe8e3ea572bda7a$var$store);
  }
  onStart() {
    $7fe8e3ea572bda7a$var$store.dragging = this;
  }
  onEnd() {
    $7fe8e3ea572bda7a$var$store.dragging = null;
  }
  onChoose(evt) {
    const _this$props6 = this.props,
      list = _this$props6.list,
      setList = _this$props6.setList;
    const newList = list.map((item, index) => {
      let newItem = item;
      if (index === evt.oldIndex) newItem = Object.assign(item, {
        chosen: true
      });
      return newItem;
    });
    setList(newList, this.sortable, $7fe8e3ea572bda7a$var$store);
  }
  onUnchoose(evt) {
    const _this$props7 = this.props,
      list = _this$props7.list,
      setList = _this$props7.setList;
    const newList = list.map((item, index) => {
      let newItem = item;
      if (index === evt.oldIndex) newItem = Object.assign(newItem, {
        chosen: false
      });
      return newItem;
    });
    setList(newList, this.sortable, $7fe8e3ea572bda7a$var$store);
  }
  onSpill(evt) {
    const _this$props8 = this.props,
      removeOnSpill = _this$props8.removeOnSpill,
      revertOnSpill = _this$props8.revertOnSpill;
    if (removeOnSpill && !revertOnSpill) (0, $eb03e74f8f7db1f3$export$1d0aa160432dfea5)(evt.item);
  }
  onSelect(evt) {
    const _this$props9 = this.props,
      list = _this$props9.list,
      setList = _this$props9.setList;
    const newList = list.map(item => Object.assign(item, {
      selected: false
    }));
    evt.newIndicies.forEach(curr => {
      const index = curr.index;
      if (index === -1) {
        console.log(`"${evt.type}" had indice of "${curr.index}", which is probably -1 and doesn't usually happen here.`);
        console.log(evt);
        return;
      }
      newList[index].selected = true;
    });
    setList(newList, this.sortable, $7fe8e3ea572bda7a$var$store);
  }
  onDeselect(evt) {
    const _this$props10 = this.props,
      list = _this$props10.list,
      setList = _this$props10.setList;
    const newList = list.map(item => Object.assign(item, {
      selected: false
    }));
    evt.newIndicies.forEach(curr => {
      const index = curr.index;
      if (index === -1) return;
      newList[index].selected = true;
    });
    setList(newList, this.sortable, $7fe8e3ea572bda7a$var$store);
  }
}
/* eslint-disable-next-line */
$7fe8e3ea572bda7a$export$11bbed9ee0012c13.defaultProps = {
  clone: item => item
};
var $faefaad95e5fcca0$exports = {};
$parcel$exportWildcard(module.exports, $faefaad95e5fcca0$exports);